export default function() {
	const inView = (el) => {
		const scroll = window.scrollY || window.pageYOffset
		const boundsTop = el.getBoundingClientRect().top + scroll

		const viewport = {
			top: scroll,
			bottom: scroll + window.innerHeight
		}
	
		const bounds = {
			top: boundsTop,
			bottom: boundsTop + el.clientHeight
		}
	
		//ritorna true or false, vede se elemento è nella viewport
		return ( bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom)
		|| ( bounds.top <= viewport.bottom && bounds.top >= viewport.top)
	}


	const elements = document.querySelectorAll('.js-fade-in')

	elements.forEach((el) => {
		if (inView(el)) {
			el.classList.add('done')
		}
	})

	window.onscroll = () => {
		elements.forEach((el) => {
			if (inView(el)) {
				el.classList.add('done')
			}
		})
	}

	window.onload = () => {
		elements.forEach((el) => {
			if (inView(el)) {
				el.classList.add('done')
			}
		})
	}
}